import React, { useState } from 'react';
import {
    useRecordContext,
    useCreate,
    Confirm,
    useNotify,
    useRedirect
} from 'react-admin';

import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { createButtonCss } from '../shared/Styles/buttonStyles';

export const ConfirmDialogCreateButtonCustom = ({ titolo, messaggio, servizio, redirectPath }) => {
    const record = useRecordContext();
    const [open, setOpen] = useState(false);
    const notify = useNotify();
    const redirect = useRedirect();

    const [create, { isLoading }] = useCreate();

    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);
    const handleConfirm = () => {

        /*
        CREATO
        IN CORSO
        COMPLETATO
        SCADUTO 
        */
        /* TODO: serve microservizio scheduatore per SCADUTO */

        const newRecord = {
            "usersId": record.id,
            "descrizione": "Quiz Candidato " + record.email,
            "stato": "CREATO",
            "flAttivo": 1,
            "flVisibile": 1,
            "flAnnullato": 0,
            "ordinamento": 0
        };

        create(servizio, { data: newRecord }, {
            onSuccess: ({ data }) => {
                notify('Record creato con successo', 'info');
                window.location.reload();  // Esegue il refresh della pagina
            },
            onFailure: (error) => {
                notify(`Errore: ${error.message}`, 'warning');
            }
        });
        setOpen(false);
    };

    return (
        <>
            {isLoading ? (
                <CircularProgress size={24} sx={{ color: '#e85a2c' }} />
            ) : (
                <Button
                    sx={createButtonCss}
                    onClick={handleClick}
                    variant="contained"
                    size="small"
                    endIcon={<AddIcon />}
                    component="label"
                    color="primary"
                >
                    CREA
                </Button>
            )}
            <Confirm
                isOpen={open}
                loading={isLoading}
                title={titolo || "Crea record"}
                content={messaggio}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
                confirm="Si"
                cancel="No"
            />
        </>
    );
};
